import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgCalendarPlus(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.25 2.75V4.75L19.75 4.75V2.75L22.25 2.75V4.75H28C28.6904 4.75 29.25 5.30964 29.25 6L29.25 17.25H26.75V15.25L5.25 15.25L5.25 26.75L17.25 26.75V29.25L4 29.25C3.66848 29.25 3.35054 29.1183 3.11612 28.8839C2.8817 28.6495 2.75 28.3315 2.75 28L2.75 6C2.75 5.30964 3.30964 4.75 4 4.75L9.75 4.75V2.75H12.25ZM19.75 7.25V9.25H22.25V7.25H26.75V12.75L5.25 12.75L5.25 7.25L9.75 7.25V9.25L12.25 9.25L12.25 7.25L19.75 7.25Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M26.25 23.7498L29.2499 23.7497L29.25 26.2497L26.25 26.2498L26.25 29.25L23.75 29.25L23.75 26.2499L20.75 26.25L20.7499 23.75L23.75 23.7499L23.75 20.75L26.25 20.75L26.25 23.7498Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCalendarPlus);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
